import { usePosthog } from '../use-posthog'

enum EventSearch {
  SEARCH_START_ACTION = 'search_start_action'
}

export const useEventSearch = () => {
  const { trackEvent } = usePosthog()

  const searchStartAction = () => {
    trackEvent({
      name: EventSearch.SEARCH_START_ACTION,
      eventProperties: {
        displayName: 'Realizar busqueda'
      }
    })
  }

  return {
    searchStartAction
  }
}
